import React from 'react';

interface Props {
  className?: string;
  size?: number;
}
export const IconProfile: React.FC<Props> = ({ className = '', size = 40 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.155136 28.1125L4.50436 19.8375L0.199516 11.9C0.0973053 11.7109 0.0415306 11.4945 0.037899 11.2731C0.0342636 11.0517 0.082901 10.8332 0.178837 10.6399C0.274769 10.4466 0.414558 10.2855 0.583893 10.1731C0.753231 10.0607 0.946033 10.0009 1.14259 10H35.781C36.3695 10 36.9339 10.2634 37.3501 10.7322C37.7662 11.2011 38 11.837 38 12.5V27.5C38 28.163 37.7662 28.7989 37.3501 29.2678C36.9339 29.7366 36.3695 30 35.781 30H1.1093C0.913471 30 0.721138 29.9415 0.551838 29.8306C0.382542 29.7197 0.242317 29.5603 0.145401 29.3686C0.0484848 29.1769 -0.00166702 28.9597 4.19617e-05 28.7391C0.00175095 28.5185 0.0552635 28.3023 0.155136 28.1125Z"
        fill="#725CFF"
      />
      <path
        d="M14.1753 22.9903H15.2405L15.25 17H14.1848V21.2165L11.0747 17H10V23H11.0747V18.7835L14.1753 22.9903Z"
        fill="white"
      />
      <path
        d="M17.9035 17.9693H21.2609L21.2514 17H16.8288V22.9128H21.2609V21.9435H17.9035V20.3829H20.947V19.4136H17.9035V17.9693Z"
        fill="white"
      />
      <path
        d="M28.0707 22.9709H29.1454L31 17H29.8302L28.5652 21.294L27.1766 17H26.0163L24.5707 21.294L23.3152 17H22.1549L24.0571 22.9903H25.1223L26.5965 18.5218L28.0707 22.9709Z"
        fill="white"
      />
    </svg>
  );
};

export default IconProfile;
